var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.openQuanSystem}},[_vm._v("打开 中国工农红军四渡赤水纪念馆")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }